import { render } from "./PromptExamples.vue?vue&type=template&id=510f157d&scoped=true&ts=true"
import script from "./PromptExamples.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromptExamples.vue?vue&type=script&setup=true&lang=ts"

import "./PromptExamples.vue?vue&type=style&index=0&id=510f157d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510f157d"],['__file',"src/components/PromptExamples.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "510f157d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('510f157d', __exports__)) {
    api.reload('510f157d', __exports__)
  }
  
  module.hot.accept("./PromptExamples.vue?vue&type=template&id=510f157d&scoped=true&ts=true", () => {
    api.rerender('510f157d', render)
  })

}


export default __exports__